import { Link } from 'react-router-dom'
import plans from '../lib/plans'
import { ReactComponent as ArrowUpward } from '../icons/arrow_upward.svg'
import { ReactComponent as ArrowDownward } from '../icons/arrow_downward.svg'
import { ReactComponent as PhoneIcon } from '../icons/telephone.svg'

export const PlansShowcase = () => {
  return (
    <section id="planes" className="plans-showcase">
      <div className="container">
        <div className="plans-header">
          <h2 className="plans-title">Nuestros Planes de Internet</h2>
          <p className="plans-subtitle">
            Elige el plan perfecto para tu hogar. Sin permanencia mínima.
          </p>
        </div>

        <div className="plans-grid">
          {plans.map((plan, index) => (
            <div key={plan.id} className={`plan-card ${index === 1 ? 'featured' : ''}`}>
              {index === 1 && <div className="plan-badge">Más Popular</div>}
              
              <div className="plan-header">
                <h3 className="plan-name">{plan.title}</h3>
                <div className="plan-price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">/mes</span>
                </div>
              </div>

              <div className="plan-speeds">
                <div className="speed-item">
                  <ArrowUpward className="speed-icon upload" />
                  <div className="speed-details">
                    <span className="speed-label">Subida</span>
                    <span className="speed-value">{plan.speedUp}</span>
                  </div>
                </div>
                <div className="speed-item">
                  <ArrowDownward className="speed-icon download" />
                  <div className="speed-details">
                    <span className="speed-label">Bajada</span>  
                    <span className="speed-value">{plan.speedDown}</span>
                  </div>
                </div>
              </div>

              <div className="plan-features">
                <ul>
                  <li>✓ Sin contratos forzosos</li>
                  <li>✓ Configuración profesional</li>
                  <li>✓ Soporte técnico 24/7</li>
                  <li>✓ Sin límite de dispositivos</li>
                  <li>✓ Facturación mensual</li>
                </ul>
              </div>

              <div className="plan-actions">
                <a 
                  href="tel:8180178779" 
                  className="plan-cta primary"
                >
                  Contratar Ahora
                </a>
                <a 
                  href="tel:8180178779" 
                  className="plan-cta secondary"
                >
                  <PhoneIcon className="cta-icon" />
                  Más Información
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="plans-note">
          <p>
            * Precios incluyen IVA. Velocidades sujetas a disponibilidad en tu zona.
            <br />
            Consulta términos y condiciones.
          </p>
        </div>
      </div>
    </section>
  )
}
